export default __webpack_public_path__ + "static/media/trusted.fb2496b2.svg";